export default __webpack_public_path__ + "static/media/juegoregistro_perder.b8c6f57a.png";